<template>
  <div
    class="the-navbar__user-meta flex items-center">
    <div>

      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

        <div class="con-img ml-3" style="display: flex; align-items: center;">
          <vs-avatar color="primary" :text="name" style="margin-right: 8px; font-size: 17px; font-weight: bold;"/>
          <h5 style="margin: 0;">{{ name }}</h5>
        </div>

        <vs-dropdown-menu class="vx-navbar-dropdown">
          <ul style="min-width: 9rem">
<!--            Será realizado tratamento em outra issue-->
<!--            <li-->
<!--              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
<!--              @click="$router.push('/profile')"-->
<!--            >-->
<!--              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />-->
<!--              <span class="ml-2">Perfil</span>-->
<!--            </li>-->

              <li v-if="!verifyTwoFactor"
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="$router.push('/user-settings').catch(() => {})"
                >
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Configurações</span>
            </li>
            <vs-divider class="m-1" v-if="!verifyTwoFactor"/>

            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="exitApplication()"
            >
              <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
              <span class="ml-2">Sair</span>
            </li>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
  import { getIp } from '@/utils'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        verifyTwoFactor: false
      }
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      nameUser() {
        return this.$store.state.name;
      },
      ...mapGetters([
        'token',
        'name'
      ]),
    },
    watch:{
      '$store.state.users.users': {
        handler(newValue) {
          const email = localStorage.getItem('email');
          const userData = newValue.find(user => user.email === email);
          if (userData && userData.twofactor_activity === true && userData.is_two_factor_validated === false) {
            this.verifyTwoFactor = true;
          } else {
            this.verifyTwoFactor = false;
          }
        },
        deep: true
      }
    },
    methods: {
      async exitApplication() {
        const ip = await getIp();
        await this.$store.dispatch('exitApplication', {ip: ip});
        this.$router.push('/login');
        this.$vs.loading.close();
        localStorage.removeItem('email');
        localStorage.removeItem('name');
        localStorage.removeItem('permissions');
        localStorage.removeItem('twoFactor');
      },
    },
    async mounted(){
      await this.$store.dispatch('getAllUsers')
    }
  }
</script>
